import QuantitySelector from './quantity-selector';

export default class SplitQuantitySelector extends QuantitySelector {
  static QUANTITY_SELECTOR_SELECTOR = '.js-split-cart';
  static readonly QUANTITY_INPUT_SELECTOR = '.js-qty-selector-input';
  static readonly QUANTITY_SELECTOR_LEFT = '.js-qty-left';
  static readonly QUANTITY_SELECTOR_RIGHT = '.js-qty-right';

  constructor(protected container: JQuery) {
    super(container);
    this.bindChangeSibling();
  }

  static initAll(): void {
    $(SplitQuantitySelector.QUANTITY_SELECTOR_SELECTOR).map((i, el) => new SplitQuantitySelector($(el)));
  }

  bindChangeSibling(): void {
    this.input.on('change', (e) => {
      const quantitySum = $(e.target).closest('.js-table-row').data('quantity') as number;
      const affectedQuantitySelectorInput = $(e.target);
      const max = affectedQuantitySelectorInput.data('max') as number;
      const diffValue = quantitySum - (affectedQuantitySelectorInput.val() as number);
      const opposingQuantitySelector = $(e.target).hasClass('js-qty-left')
        ? $(e.target).closest('.js-table-row').find(SplitQuantitySelector.QUANTITY_SELECTOR_RIGHT)
        : $(e.target).closest('.js-table-row').find(SplitQuantitySelector.QUANTITY_SELECTOR_LEFT);

      opposingQuantitySelector.find('.js-qty-selector-plus , .js-qty-selector-minus').prop('disabled', false);

      // eslint-disable-next-line consistent-return
      opposingQuantitySelector.find('.js-qty-selector-minus').prop('disabled', () => {
        if (diffValue === 0) return 'disabled';
      });

      // eslint-disable-next-line consistent-return
      opposingQuantitySelector.find('.js-qty-selector-plus').prop('disabled', () => {
        if (diffValue >= max) return 'disabled';
      });

      opposingQuantitySelector.find(SplitQuantitySelector.QUANTITY_INPUT_SELECTOR).val(diffValue);
      this.container.trigger('splitOrderQuantityChange');
    });
  }
}
